import { authRoles } from "../../auth/authRoles";
import File from "./GCG/File/File";
import Konten from "./GCG/Konten";
import Karir from "./Karir/Karir";
import Kontak from "./Kontak/Kontak";
import Manajemen from "./Manajemen/Manajemen";

const HalamanRoutes = [
  {
    path: "/kontak_kami",
    exact: true,
    component: Kontak,
    auth: authRoles.all,
  },
  {
    path: "/karir",
    exact: true,
    component: Karir,
    auth: authRoles.all,
  },
  {
    path: "/manajemen_perusahaan",
    exact: true,
    component: Manajemen,
    auth: authRoles.all,
  },
  {
    path: "/gcg",
    exact: true,
    component: Konten,
    auth: authRoles.all,
  },
  {
    path: "/gcg_file",
    exact: true,
    component: File,
    auth: authRoles.all,
  },
];

export default HalamanRoutes;
